<template>
    <div class="xi" style="background: #F5F5F5;">
        <hd-com></hd-com>
        <div class="banner">
            <div class="banner-text">
                <p>当前位置：<router-link to="/index">首页</router-link><i class="el-icon-arrow-right"></i><a>普通问诊</a><i class="el-icon-arrow-right"></i><a>医生详情</a><i class="el-icon-arrow-right"></i><a>问诊详情</a></p>
            </div>
        </div>
        <div class="contentRes">
            <div class="contentList">
                <div class="contentStep1Box">
                    <div class="step1Title">预约信息 <span style="color:#EC0101">*</span></div>
                    <div class="step2Title" style="margin-bottom:15px">患者姓名<span style="color:#EC0101">*</span></div>
                    <el-input
                        class="diseaseBox"
                        placeholder="请输入患者姓名"
                        v-model="patientName">
                    </el-input>
                    <div class="step2Title" style="margin-bottom:15px;margin-top:25px">所患疾病<span style="color:#EC0101">*</span></div>
                    <el-input
                        class="diseaseBox"
                        type="textarea"
                        :rows="3"
                        placeholder="请输入所患疾病/或者症状"
                        v-model="patientDis">
                    </el-input>
                    <div class="step2Title" style="margin-bottom:15px;margin-top:25px">就诊类型</div>
                    <div  class="DocTopFlexC">
                        <div :class="patientType == 0 ? 'stepBtnBox' : 'canBtnBox'" @click="goPatientType(0)">
                            初诊
                        </div>
                        <div :class="patientType == 1 ? 'stepBtnBox' : 'canBtnBox'" @click="goPatientType(1)">
                            复诊
                        </div>
                    </div>
                    <div class="infoDesBox">
                        <div>预约须知：</div>
                        <div class="DocTopFlexC">
                            <span>1、挂号费由医院自行设定，平台不收取任何额外费用</span>
                            <span style="margin-left:50px">2、停诊将短信通知，请保持手机畅通实名制预约</span>
                        </div>
                        <span>3、就诊人信息不符将无法取号</span>
                    </div>
                    <div  class="DocTopFlexC">
                        <div  class="surePriceBox" @click="goNextStep">确定预约  ￥{{orderDetail.price}}</div>
                    </div>
                     <div style="margin-top:15px"><el-checkbox v-model="cssagree" style="margin-right:10px"></el-checkbox> 我已经阅读并同意<router-link target="_blank" to="/company/onLineNotice"><span style="color:#E74848">《互联网风险告知书》</span> </router-link>和<router-link target="_blank" to="/company/onInfoAgress"><span style="color:#E74848">《个人信息使用授权协议》</span></router-link></div>
                </div>
            </div>
            <div class="contentListRight">
                <div style="margin: 19px 31px 28px 23px;">
                    <div class="contentListTopR">
                        <div class="contentListLineR"></div><span>温馨提示</span>
                    </div>
                    <div style="font-size: 16px;color: #FF0000;line-height: 24px;margin-top:18px">
                        本系统仅提供辅助参考功能，诊疗决策须由执业医师独立完成，提交的所有内容，仅您本人与医生可见，请放心！
                    </div>
                </div>
            </div>
        </div>
        <ft-com></ft-com>
    </div>
</template>

<script>
import { reservationMain } from "../../components/reservation/reservation";
import hdCom from '../../components/header'
import ftCom from '../../components/footer'
export default {
    components: {
        hdCom,
        ftCom
    },
    data() {
        var reservationMainItemDrug = new reservationMain(this.TokenClient, this.Services.Drug);
        return {
            reservationDomainDrug: reservationMainItemDrug,
            userInfo: this.$store.state.localData.userInfo,
            orderDetail: JSON.parse(this.$route.query.orderDetail),
            patientId:'',
            patientName:'',
            patientDis:'',
            patientType:0,
            cssagree:false
        }
    },
    mounted(){
        
    },
    methods: {
        goPatientType(e){
            this.patientType = e
        },  
        goNextStep(){
            if (!this.patientName) {
                this.$message.error('请输入患者姓名');
                return
            }
            if (!this.patientDis) {
                this.$message.error('请输入所患疾病或者症状');
                return
            }
            if (!this.cssagree) {
                this.$message.error('请勾选相关协议');
                return
            }
            var _this = this
            let params = {
                doctorAppointmentScheduleId:_this.orderDetail.scheduleId,
                scheduleDate:_this.orderDetail.scheduleDateS,
                patientName:_this.patientName,
                patientType:_this.patientType,
                disease:_this.patientDis,
                photoFile: _this.orderDetail.photoFile
            }
            _this.reservationDomainDrug.GetDoctorAppointmentOrder(params, function (data) {
                let orderParams = {
                    orderNumber:data.data.orderNumber,
                    totalMoney:data.data.totalMoney,
                    scheduleDateS:_this.orderDetail.scheduleDateS,
                    weekDayW:_this.orderDetail.weekDayW,
                    timePeriod:_this.orderDetail.timePeriod,
                    scheduleDateDay:_this.orderDetail.scheduleDateDay,
                    patientName:_this.patientName,
                    patientDis:_this.patientDis,
                    patientType:_this.patientType,
                    startTime:_this.orderDetail.startTime,
                    endTime:_this.orderDetail.endTime
                }
                _this.$router.push({
                    path: "/reservation/reservationPay",
                    query: {
                        payInfo: JSON.stringify(orderParams),
                        typeTime:1
                    },
                });
            },
            function (error) {
                 
                console.log('', error)
            })

        }
    },
}
</script>

<style scoped>
.banner-text {
    width: 1200px;
    margin: 0 auto;
    margin-top: 20px;
    margin-bottom: 10px;
}
.contentRes {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    min-height: 800px;
    margin-bottom: 20px;
}
.contentList {
    margin-top: 20px;
    width: 800px;
}
.contentListRight {
    width: 380px;
    height: 180px;
    background: #FFFFFF;
    margin-top: 20px;
}
.contentListTopR {
    display: flex;
    align-items: center;
}
.contentListLineR {
    width: 3px;
    height: 20px;
    background: #FF0000;
    border-radius: 2px;
}
.contentListTopR span {
   font-size: 20px;
   margin-left: 10px;
   color: #FF0000;
}
.DocTopFlexC {
    display: flex;
    align-items: center;
}
.DocTopFlexS {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.contentStep1Box {
    margin-top: 15px;
    padding: 30px;
    padding-bottom: 60px;
    background-color: #FFFFFF;
}
.step1Title {
    font-weight: bold;
    font-size: 16px;
    color: #333333;
}
.step2Title {
    font-size: 16px;
    color: #333333;
}
 .diseaseBox ::v-deep input{
    background: #F5F5F5 !important;
    border-radius: 4px;
    border: none;
}
 .diseaseBox ::v-deep textarea{
    background: #F5F5F5 !important;
    border-radius: 4px;
    border: none;
}
.canBtnBox {
    width: 80px;
    background: #EDEDED;
    border-radius: 4px;
    font-size: 16px;
    color: #333333;
    text-align: center;
    padding: 5px 0;
    cursor: pointer;
    margin-right: 10px;
}
.stepBtnBox {
    width: 80px;
    background: #00AFB5;
    border-radius: 4px;
    font-size: 16px;
    color: #FFFFFF;
    text-align: center;
    padding: 5px 0;
    cursor: pointer;
    margin-right: 10px;
}
.surePriceBox {
    background: #00AFB5;
    border-radius: 4px;
    font-size: 16px;
    color: #FFFFFF;
    padding: 5px 20px;
    cursor: pointer;
    margin-top: 70px;
}
.infoDesBox {
    border-radius: 4px;
    border: 1px solid #E6E6E6;
    padding: 20px;
    font-size: 14px;
    color: #666666;
    margin-top: 40px;
}
</style>
